/* eslint-disable jsx-a11y/anchor-is-valid */
import {Ripple} from 'primereact/ripple'
import {Tooltip} from 'primereact/tooltip'
import {useRef} from 'react'

const IconWrapper = ({
    id = '',
    content = '',
    icon,
    size = '25px',
    disable = false,
    tooltip = false,
    onClick = () => {},
}) => {
    const containerRef = useRef(null)

    const handleMouseEnter = () => {
        containerRef.current.style.color = 'rgb(47, 184, 171)'
    }

    const handleMouseLeave = () => {
        if (!disable) {
            containerRef.current.style.color = 'rgb(13, 148, 136)'
        }
    }
    const iconStyle = {
        fontSize: size,
        transition: 'transform 0.3s ease-in-out',
        color: !disable ? 'rgb(13, 148, 136)' : 'rgb(47, 184, 171)',
        cursor: !!disable ? 'not-allowed' : 'pointer',
    }
    const handleOnClick = () => {
        if (!disable) {
            onClick()
        }
    }
    return (
        <div
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            id={`tooltip-${id}`}
            onClick={handleOnClick}
            className={`icon-wrapper-container m-0 p-0 p-ripple flex align-items-center hover:text-primary font-medium border-round transition-duration-150 transition-colors `}>
            <span
                className="flex align-items-center icon-wrapper"
                ref={containerRef}
                style={iconStyle}>
                {icon}
            </span>
            {content && <span className="ml-2">{content}</span>}

            <Ripple />
            {!!tooltip && (
                <Tooltip
                    target={`#tooltip-${id}`}
                    position="top"
                    content={content}
                />
            )}
        </div>
    )
}

export default IconWrapper
